"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uploader = void 0;
const classnames_1 = __importDefault(require("classnames"));
const nanoid_1 = require("nanoid");
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../hooks");
const Spinner_1 = require("../Spinner");
const DriveUploader_module_css_1 = __importDefault(require("./DriveUploader.module.css"));
const Uploader_module_css_1 = __importDefault(require("./Uploader.module.css"));
const Uploader = ({ id, folderName, onUpload }) => {
    const [status, setStatus] = react_1.useState('init');
    const [session, setSession] = react_1.useState(nanoid_1.nanoid());
    const intl = hooks_1.useIntlScope('@lemonone/components/Uploader:');
    react_1.useLayoutEffect(() => {
        const script = document.createElement('script');
        const cb = `cb_${id}`;
        script.src = `https://driveuploader.com/upload/${id}/embed.js?callback=${cb}`;
        // @ts-ignore
        window[cb] = (status, result, instance) => {
            switch (status) {
                case 'init': {
                    setStatus(status);
                    if (folderName)
                        instance.setCustomSubfolderName(folderName);
                    instance.setCustomMetadata('session', session);
                    break;
                }
                case 'start': {
                    setStatus(status);
                    break;
                }
                case 'done': {
                    setStatus(status);
                    onUpload === null || onUpload === void 0 ? void 0 : onUpload(result.folder.link);
                    break;
                }
                case 'error': {
                    break;
                }
                default:
                    break;
            }
        };
        document.head.appendChild(script);
        return () => {
            // @ts-ignore
            delete window[cb];
            document.head.removeChild(script);
        };
    }, [id, session, folderName, onUpload]);
    return (react_1.default.createElement("div", { key: session, className: classnames_1.default(DriveUploader_module_css_1.default.root, Uploader_module_css_1.default.uploader, Uploader_module_css_1.default[`status-${status}`]) },
        react_1.default.createElement("div", { className: Uploader_module_css_1.default.left },
            react_1.default.createElement("input", { className: "driveuploader-replace" })),
        status === 'start' && (react_1.default.createElement("div", { className: Uploader_module_css_1.default.right },
            react_1.default.createElement(Spinner_1.Spinner, { variant: "primary", className: Uploader_module_css_1.default.right }))),
        status === 'done' && (react_1.default.createElement("div", { className: Uploader_module_css_1.default.right },
            react_1.default.createElement("button", { className: "btn", onClick: () => setSession(nanoid_1.nanoid()) }, intl('reupload'))))));
};
exports.Uploader = Uploader;
//# sourceMappingURL=Uploader.js.map